import React, { useLayoutEffect, useEffect  } from "react";
import { Link } from "react-router-dom";
import { Container, Grid, Box, Button } from '@material-ui/core';
import './Banner.css';
import AOS from 'aos';

function Banner() {
	useEffect(() => {
		AOS.init({
			disable: 'mobile'
		  });
	});
	return (
		<section id="banner">
			<div className="banner-content">
				<Container maxWidth="lg" className="text-white container">
					<Grid data-aos="zoom-in-down" data-aos-offset="80" data-aos-duration="2000" data-aos-delay="200" container className="banner-holder" spacing={0} display="flex" direction="column">
						<h1>xWin Makes Investment Easier</h1>
						<h2>DEFI Investment Management in Binance Smart Chain</h2>
						<div className="btns-holder">
							<Button variant="contained" color="primary">Launch the App</Button>
							<Button variant="contained" color="secondary">xWin Docs</Button>
						</div>
					</Grid>
				</Container>
			</div>
			<div className="value-locked-area">
				<Container maxWidth="lg">
					<Grid container spacing={0} display="flex" justify="center">
						<Box data-aos="zoom-in" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" textAlign="center">
							<h2>Total Value Locked (TVL) $1,502,535.79</h2>
							<p>Across all Vaults and XWIN Farming Pools</p>
						</Box>
					</Grid>
				</Container>
			</div>
		</section>
	);
}
export default Banner;